import type { LineItemPropertyService } from './line-item-property.services';
import type { LineItem, LineItemRequestParams } from './models/line-item.model';

export class LineItemService {
  constructor(private lineItemAttributeService: LineItemPropertyService) {}

  appendLineItemProperties(source: LineItem, destination: LineItem): LineItem {
    destination.properties = Object.assign({}, source.properties, destination.properties);
    return destination;
  }

  buildLineItem(params: LineItemRequestParams): LineItem {
    if (!params.quantity) {
      params.quantity = 1;
    }
    let item = {
      quantity: params.quantity,
      id: params.id,
    } as LineItem;
    const properties = this.lineItemAttributeService.buildProperties(params);
    if (Object.keys(properties).length > 0) {
      item = Object.assign(item, {
        properties,
      });
    }
    if (!!params.sellingPlanId) {
      item = Object.assign(item, {
        selling_plan: params.sellingPlanId,
      });
    }
    return item;
  }

  buildBuyItNowLineItem(params: LineItemRequestParams): LineItem {
    if (!params.quantity) {
      params.quantity = 1;
    }
    let item = {
      quantity: params.quantity,
      variant_id: params.id,
    } as LineItem;
    const properties = this.lineItemAttributeService.buildProperties(params);
    if (Object.keys(properties).length > 0) {
      item = Object.assign(item, {
        properties,
      });
    }
    if (!!params.sellingPlanId) {
      item = Object.assign(item, {
        selling_plan_id: params.sellingPlanId,
      });
    }
    return item;
  }
}
